import { AppStoreState } from 'app/redux/store';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useIsLogin = () => {
  const { auth } = useSelector((state: AppStoreState) => state.global);
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    if (auth.id) {
      setIsLogin(true);
    }
  }, [auth]);

  return isLogin;
}

export default useIsLogin;
